// extracted by mini-css-extract-plugin
export var clauseRow = "_bx-6";
export var emptyState = "_bx-d";
export var filterContent = "_bx-a";
export var filterGroup = "_bx-1";
export var filterGroupContainer = "_bx-0";
export var nestedGroup = "_bx-2";
export var nestedGroupContent = "_bx-b";
export var nestedGroupDepth1 = "_bx-3";
export var nestedGroupDepth2 = "_bx-4";
export var nestedGroupDepth3 = "_bx-5";
export var nestedGroupEmpty = "_bx-c";
export var operatorAnd = "_bx-8";
export var operatorOr = "_bx-9";
export var operatorToggle = "_bx-7";
export var removeGroupButton = "_bx-e";